export const COMPANY = {
  name: "S Mahadeva Properties",
  tagline: "Building Trust. Creating Legacies.",
  founder: "Sneha Dixit",
  experienceYears: 10,
  phones: ["+91 78785 87743", "+91 88494 37638"],
  whatsapp: "918849437638",
  whatsappDisplay: "+91 88494 37638",
  email: "smahadevaproperties@gmail.com",
  address: "Vadodara, Gujarat, India",
  logo: "https://customer-assets.emergentagent.com/job_dholera-invest-7/artifacts/py1zf8rp_Logo%20V.png",
  founderPhoto: "https://customer-assets.emergentagent.com/job_dholera-invest-7/artifacts/4wlx7gvy_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2006_58_11%20PM.png",
  stats: {
    clients: "500+",
    acres: "1500+",
    years: "10+",
    pan: "PAN India",
  },
};

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Projects", path: "/projects" },
  { name: "Properties", path: "/properties" },
  { name: "Contact", path: "/contact" },
];

export const buildWhatsAppLink = (message = "") => {
  const text = encodeURIComponent(
    message ||
      "Hello, I'm interested in Dholera Smart City investment opportunities. Please share details."
  );
  return `https://wa.me/${COMPANY.whatsapp}?text=${text}`;
};

export const telLink = (phone) => `tel:${phone.replace(/\s+/g, "")}`;
